import React, { useContext } from 'react'
import editIcon from '../icons/editing.png';
import deleteIcon from '../icons/delete.png';
import noteContext from '../context/notes/noteContext';

export default function NoteItem(props) {
    const { title, description ,tag} = props.note;
    const context = useContext(noteContext);
    const { deleteNote } = context;
    return (
        <div className='col-md-3'>
            <div className="card my-3">
                <div className="card-body">
                    <div className="d-flex justify-content-around">
                        <div>
                            <h5 className="card-title">{title}</h5>
                        </div>
                        <div>
                            <img className='mx-2' src={editIcon} alt="edit" onClick={()=>{props.updateNote(props.note)}} height={'20px'} />
                            <img className='mx-2' src={deleteIcon} onClick={() => {
                                deleteNote(props.note._id);
                                props.showAlert("Note was deleted","warning")
                            }} alt="delete" height={'20px'} />
                        </div>
                    </div>
                    <p className="card-text">{description}</p>
                    <p className="card-text">{tag}</p>
                </div>
            </div>
        </div>
    )
}
